
const setOrderDetail = (state, data) => {
  state.orderDetail = data;
};

const setAttendanceTimes = (state, data) => {
  state.attendanceTimes = data;
};

const setListSignAndTally = (state, data) => {
  state.listSignAndTally = data;
};

export default {
  setOrderDetail,
  setAttendanceTimes,
  setListSignAndTally
};
